import React, { FC, useEffect, useRef, useState } from 'react';

import { ReactComponent as ClipBoardIcon } from '../../../assets/images/svg/clip_pad.svg';

interface Props {
    reference?: any;
    input: string;
    inline?: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const copyToClipboard = async (text: string) => {
    if (!text) return false;
    try {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (err) {
        // Continue to fallback
    }

    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.top = '-9999px';
        textArea.style.left = '-9999px';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        return successful;
    } catch (err) {
        return false;
    }
};

const Clipboard: FC<Props> = ({ reference, input, inline = false, className = '', style }) => {
    const [state, setState] = useState({
        isCopied: ''
    });

    useEffect(() => {
        if (state.isCopied !== '') {
            const timer = setTimeout(() => {
                setState({ isCopied: '' });
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [state.isCopied]);

    const handleCopyClipboard = (event?: any) => {
        if (event && typeof event.stopPropagation === 'function') {
            event.stopPropagation();
        }

        if (reference && typeof reference.select === 'function') {
            try {
                reference.select();
            } catch (err) {}
        }

        if (event && event.target && typeof event.target.focus === 'function') {
            try {
                event.target.focus();
            } catch (err) {}
        }

        if (input) {
            copyToClipboard(input);
        }

        setState({ isCopied: 'Copied' });
    };

    const handleClearCopy = (event?: any) => {
        if (event && typeof event.stopPropagation === 'function') {
            event.stopPropagation();
        }
        setState({ isCopied: '' });
    };

    const isCopied = Boolean(state.isCopied);

    return (
        <div
            className={`oi-clipboard ${inline ? 'oi-clipboard--inline' : ''} ${className}`}
            style={style}
            title={inline ? 'Copy to clipboard' : undefined}>
            <div
                className={`${isCopied ? 'oi-clipboard__msg--mod' : ''} oi-clipboard__msg`}
                onClick={handleClearCopy}>
                {state.isCopied}
            </div>

            <button
                type="button"
                className={isCopied && !inline ? 'oi-clipboard__copy' : 'oi-clipboard__copy--mod'}
                onClick={handleCopyClipboard}>
                <ClipBoardIcon className="oi-clipboard__svg" />
            </button>
        </div>
    );
};

export default Clipboard;
